export function getUserName(user) {
  if (user?.firstname && user?.lastname)
    return `${user.firstname || ''} ${user.lastname || ''}`;

  if (user?.first_name && user?.last_name)
    return `${user.first_name || ''} ${user.last_name || ''}`;
}
